<template>
  <div class="github-corner">
    <svg
      width="120"
      height="120"
      viewBox="0 0 250 250"
    >
      <a
        :fill="discordcolor"
        href="https://github.com/NNTin/discord-logo"
        style="pointer-events:auto"
      >
        <path d="M0,0 L250,250 L250,0 Z" />
      </a>
      <g class="octocat">
        <path
          :fill="discordfill"
          d="M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"
        />
        <path
          d="M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2"
          :fill="discordcolor"
          style="transform-origin: 130px 106px;"
          class="octo-arm"
        />
        <path
          d="M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z"
          :fill="discordcolor"
          class="octo-body"
        />
        <text
          x="240px"
          y="-10px"
          class="octo-click-text"
          :stroke="discordcolor"
          :fill="discordcolor"
        >CLICK</text>
        <g
          class="octo-glasses"
          visibility="hidden"
        >
          <svg
            :fill="discordfill"
            width="640"
            height="480"
          >
            <defs>
              <symbol
                id="glasses"
                viewBox="0 0 512 512"
              >
                <path d="m465.4,247c-2.2,-22 -12.4,-43 -28.9,-58.4c-17.1,-15.9 -39.3,-24.7 -62.7,-24.7c-41.5,0 -77.3,27.4 -88.5,67c-7,-7 -18.5,-11.7 -29.3,-11.7c-10.8,0 -22.3,4.7 -29.3,11.7c-11.2,-39.6 -47,-67 -88.5,-67c-23.3,0 -45.6,8.7 -62.7,24.6c-16.5,15.5 -26.7,36.5 -28.9,58.5l-14.6,0l0,18l14.6,0c2.2,22 12.4,43 28.9,58.4c17.1,15.9 39.3,24.7 62.7,24.7c50.8,0 92.1,-41.2 92.1,-92c0,-0.1 0,-0.1 0,-0.1l0,0c0,-9.9 11.5,-21.6 25.7,-21.6s25.7,11.7 25.7,21.6l0,0c0,0 0,0 0,0.1c0,50.8 41.3,92 92.1,92c23.3,0 45.6,-8.7 62.7,-24.7c16.5,-15.4 26.7,-36.5 28.9,-58.5l14.6,0l0,-18l-14.6,0l0,0.1z" />
              </symbol>
            </defs>
            <g>
              <use
                x="530"
                y="-70"
                xlink:href="#glasses"
                transform="rotate(45 100,75) matrix(0.185,0,0,0.185,0,0) "
              />
            </g>
          </svg>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'GithubCorner',
	props: {
		discordcolor: {
      type: String,
      default: '#7289DA'
		},
    discordfill: {
      type: String,
      default: '#23272A'
    }
	},
  data () {
    return {
    }
  }
}
</script>

<style>
.github-corner {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
}

.github-corner:hover .octocat{
  transform-origin: center;
  animation: octocat-grow 5s ease-in-out forwards;
}
@keyframes octocat-grow{
  16%, 66%{
    transform: scale(1.2);
  }
  33%{
    transform: scale(1.1);
  }
  50%, 100%{
    transform: scale(1.3);
  }
  83%{
    transform: scale(1.4);
  }
}

.octo-click-text {
  font-weight: normal;
  text-anchor: middle;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 20px;
  stroke-width: 2px;
  transform: rotate(45deg);
  opacity: 0;
}

.github-corner:hover .octo-click-text {
  animation: octocat-text 5s linear forwards
}
@keyframes octocat-text {
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.github-corner:hover .octo-arm{
  animation: octocat-wave 400ms linear infinite;
}

@keyframes octocat-wave {
  0%,50%,100% {
    transform: rotate(0)
  }
  25% {
    transform: rotate(-25deg)
  }
  75% {
    transform: rotate(10deg)
  }
}

.github-corner .octo-glasses{
  visibility: visible;
  opacity: 0;
  transition: opacity 5s;
}
.github-corner:hover .octo-glasses{
  opacity: 1;
  animation: octocat-glass-wiggle 400ms linear forwards;
  animation-delay: 4s;
}
@keyframes octocat-glass-wiggle {
  0%, 50%, 100% {
    transform: translateX(0px) translateY(0px);
  }
  25%, 75% {
    transform: translateX(3px) translateY(-3px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GithubCorner.vue